import React from 'react';
import { Text, TextProps, StyleSheet } from 'react-native';

import { colors, typography } from '../tokens';

type TypographyVariant = keyof typeof typography;

interface DSTextProps extends TextProps {
  variant?: TypographyVariant;
  color?: string;
  align?: 'left' | 'center' | 'right';
  uppercase?: boolean;
}

export const DSText: React.FC<DSTextProps> = ({
  variant = 'body',
  color = colors.onSurface,
  align,
  uppercase,
  style,
  children,
  ...rest
}) => {
  const typo = typography[variant];
  return (
    <Text
      style={[
        styles.base,
        typo,
        { color },
        align ? { textAlign: align } : undefined,
        uppercase ? styles.uppercase : undefined,
        style,
      ]}
      {...rest}
    >
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  base: {
    // Ensure accessibility font scaling is respected (default behavior)
  },
  uppercase: {
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
});
